import { z } from "zod";
import {
  isTreezorCompanyTaxPayerIdRequired,
  TaxResidenceSchema,
  TreezorCountryCodeSchema,
  UserSchema,
} from "../treezor/index.js";

export default {
  params: z
    .object({
      accountId: z.string(),
      legalName: UserSchema.shape.legalName,
      legalRegistrationNumber: UserSchema.shape.legalRegistrationNumber,
      legalForm: UserSchema.shape.legalForm,
      legalRegistrationDate: z.union([z.iso.date(), z.literal("")]),
      legalAnnualTurnOver: UserSchema.shape.legalAnnualTurnOver,
      legalNetIncomeRange: UserSchema.shape.legalNetIncomeRange,
      legalNumberOfEmployeeRange: UserSchema.shape.legalNumberOfEmployeeRange,
      legalSectorType: UserSchema.shape.legalSectorType,
      legalSector: UserSchema.shape.legalSector,
      legalShareCapital: UserSchema.shape.legalShareCapital,
      legalTvaNumber: UserSchema.shape.legalTvaNumber,
      phone: UserSchema.shape.phone,
      address1: UserSchema.shape.address1,
      address2: UserSchema.shape.address2,
      address3: UserSchema.shape.address3.unwrap(),
      postcode: UserSchema.shape.postcode,
      city: UserSchema.shape.city,
      country: z.union([TreezorCountryCodeSchema, z.literal("")]),
      entitySanctionsQuestionnaire: UserSchema.shape.entitySanctionsQuestionnaire,
      activityOutsideEu: UserSchema.shape.activityOutsideEu,
      economicSanctions: UserSchema.shape.economicSanctions,
      residentCountriesSanctions: UserSchema.shape.residentCountriesSanctions,
      involvedSanctions: UserSchema.shape.involvedSanctions,
      taxResidence: z
        .object({
          country: TaxResidenceSchema.shape.country,
          taxPayerId: TaxResidenceSchema.shape.taxPayerId,
        })
        .nullable(),
    })
    .refine(
      (data) =>
        !data.taxResidence ||
        !isTreezorCompanyTaxPayerIdRequired(data.taxResidence.country) ||
        !!data.taxResidence.taxPayerId?.trim(),
      {
        path: ["taxResidence", "taxPayerId"],
        message: "taxPayerId is required when the tax residence country is US or IT",
      },
    ),
  response: z.object({
    success: z.boolean(),
  }),
};
